<template>
    <div class="user">
        <div class="search-bar">
            <el-row :gutter="20">
                <div class="options-box">
                    <div class="options">
                        <el-col v-for="option in searchOptions" :key="option.key">
                            <div v-if="option.type === 'select'">
                                {{option.label}}
                                <el-select v-model="option.value" :placeholder="option.placeholder" class="input-width" clearable @change="searchSelectFn(option)">
                                    <el-option v-for="(selectOption,index)  in option.items" :key="'items'+index" :label="selectOption" :value="index"></el-option>
                                </el-select>
                            </div>
                            <div v-if="option.type === 'input'">
                                {{option.label}}
                                <el-input maxlength="18" v-model="option.value" :placeholder="option.placeholder" class="input-width"></el-input>
                            </div>                            
                        </el-col>
                        <div class="option-date-picker">
                            <span>添加时间</span>
                            <el-date-picker class="edp" value-format="yyyy-MM-dd"  v-model="dateGroup[0]" type="date" :picker-options="pickerOptions" placeholder="开始时间"></el-date-picker> 
                            <el-date-picker class="edp" value-format="yyyy-MM-dd"  v-model="dateGroup[1]" type="date" :picker-options="pickerOptions" placeholder="结束时间"></el-date-picker>                                  
                        </div>
                    </div>
                    <el-button type="primary" icon="el-icon-search" size="small" @click="search">查询</el-button> 
                </div>               
            </el-row>
        </div>    
        <div class="table-box">
            <el-table :data="tableData" v-loading="loading"
                    element-loading-text="拼命加载中"
                    element-loading-spinner="el-icon-loading"
                    element-loading-background="rgba(0, 0, 0, 0.8)" 
                    stripe style="width: 100%; font-size:14px" empty-text="暂无数据">
                <el-table-column type="index" align="center" label="序号"></el-table-column>
                <el-table-column prop="username" align="center" label="用户姓名"></el-table-column>
                <el-table-column prop="user_idcard" align="center" label="身份证号" width="180">
                    <template slot-scope="scope">
                        <span v-if="scope.row.user_idcard.length">{{scope.row.user_idcard.substring(0,8)+'******'+scope.row.user_idcard.substring(scope.row.user_idcard.length-4)}}</span>
                        <span v-else>--</span>                    
                    </template>
                </el-table-column>
                <el-table-column prop="created_time" align="center" label="添加时间" width="180"></el-table-column>
                <el-table-column align="center" label="绑定设备数">
                    <template slot-scope="scope">
                        <el-button type="text" @click="lookDevice(scope.row)">{{scope.row.equipment_total}}</el-button>
                    </template>
                </el-table-column>
                <el-table-column prop="survey_total" align="center" label="检测次数"></el-table-column>
                <el-table-column prop="report_view_total" align="center" label="查看报告次数"></el-table-column>
                <el-table-column prop="last_survey_time" align="center" label="最近检测时间">
                    <template slot-scope="scope">
                        <span v-if="scope.row.last_survey_time == null">无</span>
                    </template>
                </el-table-column>
                <el-table-column fixed="right" align="center" label="操作">
                    <template slot-scope="scope">
                        <el-button @click="handleDetails(scope.row)" type="text" size="small">查看详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="pagination-box">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20, 30, 40, 50]" :page-size="size"
                layout="total, sizes, prev, pager, next, jumper" :total="total" :size="size" :current-page="page">                
            </el-pagination>
            <el-button type="primary" size="mini">GO</el-button>
            <!-- <el-pagination background @current-change="handleCurrentChange" layout="prev, pager, next" :total="total" :size="size" :current-page="page"></el-pagination>                 -->
        </div>
        <el-dialog title="绑定设备详情" :visible.sync="deviceDialog" width="50%">
            <el-table :data="deviceTableData" stripe style="width: 100%; font-size:14px">
                <el-table-column type="index" label="序号"></el-table-column>
                <el-table-column prop="bind_device_sn" align="center" label="设备ID"></el-table-column>
                <el-table-column prop="device_name" align="center" label="设备名称"></el-table-column>
                <el-table-column prop="bind_time" align="center" label="绑定时间"></el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination @current-change="handleCurrentChange_device" 
                    layout="total, prev, pager, next" :total="device_total" :size="device_size" :current-page="device_page">                
                </el-pagination>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import UserAPI from '@/model/api/usermanage'
import Bus from '@/model/utils/bus.js'
export default {
    name: 'usermanage',
    data() {
        return {
            pickerOptions: {
                shortcuts: [{
                    text: '今天',
                    onClick(picker) {
                    picker.$emit('pick', new Date());
                    }
                }, {
                    text: '昨天',
                    onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24);
                    picker.$emit('pick', date);
                    }
                }, {
                    text: '一周前',
                    onClick(picker) {
                    const date = new Date();
                    date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
                    picker.$emit('pick', date);
                    }
                }],
                disabledDate(time) {
                    return time.getTime() > Date.now() - 8.64e6
                }
            },                      // 日期选择器设置-快捷选择、最大选择当日
            page: 1,                // 当前页
            size: 10,               // 当前每页条数
            total: 0,               // 总条数
            deviceDialog: false,    // 设备详情弹窗
            dateGroup:[],           // 搜索条件-添加时间

            // 绑定设备列表参数
            device_page: 1,
            device_size: 10,
            device_total: 0,
            // 搜索条件
            searchOptions: [
                {key: 'userName', label:'用户姓名', placeholder: '请输入姓名', type: 'input', value: null},
                {key: 'careLevel', label:'身份证号', placeholder: '请输入身份证号', type: 'input', value: null},            
            ],
            // 表单数据
            tableData:[],
            // 设备详情数据
            deviceTableData:[],
            loading: false,
            curr_idcard: ''
        }
    },
    watch: {
        dateGroup:{
            handler(val) {
                if(val[1]){
                    if(val[0] > val[1]) {
                        let temp = val[0]
                        this.dateGroup[0] = val[1]
                        this.dateGroup[1] = temp
                    }
                }
            },
            deep: true
        }
    },
    created() {
        this.initGetList()
    },
    methods: {
        // 获取用户列表
        initGetList() {
            let params = {
                p: this.page,
                size: this.size,
                username: this.searchOptions[0].value,
                idcard: this.searchOptions[1].value,
                startdate: this.dateGroup[0],
                enddate: this.dateGroup[1]
            }
            for(let item in params) {
                if(!params[item]) {
                    delete params[item]
                }
            }
            this.loading = true
            // 10s后关闭 loading
            setTimeout(() => {
                this.loading = false
            },10000)
            UserAPI.getUserList(params).then(res => {
                this.loading = false
                this.tableData = res.data.data.list
                this.total = res.data.data.total
                return Promise.resolve(this.tableData)
                // return Promise.all([this.tableData,this.total])
            })
        },
        // 查看设备详情
        lookDevice(row) {
            this.deviceDialog = true
            this.curr_idcard = row.user_idcard
            this.getBindDeviceList()
        },
        // 获取绑定设备列表
        getBindDeviceList() {
            let params = {
                idcard: this.curr_idcard,
                p:this.device_page,
                size:this.device_size
            }
            this.loading = true
            UserAPI.getUserDeviceList(params).then(res => {
                this.loading = false
                this.deviceTableData = res.data.data.list
                this.device_total = res.data.data.total
                return Promise.resolve(this.deviceTableData)
                // return Promise.all([this.deviceTableData,this.device_total])
            })
        },
        // 查看详情
        handleDetails(row) {
            Bus.$emit('updatehealthdata',row.user_idcard)
            this.$router.push({path: '/userdetails',query:{id:row.user_idcard}} )   
        },
        // 点击搜索
        search() {
            this.page = 1
            this.initGetList()
        },
        // 分页改变
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`)
            this.page = val
            this.initGetList()
        },
        // size改变
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.tableData = []
            this.size = val
            this.initGetList()
        },
        // 分页改变
        handleCurrentChange_device(val) {
            console.log(`当前页: ${val}`)
            this.device_page = val
            this.getBindDeviceList()
        }
    }
}
</script>
<style lang="scss" scoped>
.user{
    background: #f1f2f7;
    padding: 10px;
    .search-bar{
        width: 100%;
        height: 50px;
        line-height: 50px;
        background: #fff;
        margin-bottom: 10px;
        border-radius: 5px;
        .options-box{
            display: flex;
            justify-content: space-between; 
            padding: 0 20px; 
            .options{
                display: flex;
                justify-content: flex-start; 
            } 
            .option-date-picker{
                display: flex;
                flex-direction: row;
                span{
                    width: 70px;
                    text-align: right;
                    margin-right: 5px;
                }
                .edp{
                    margin-right: 10px;
                    width: 150px;
                }
            } 
            .el-button{
                margin: 10px;
            }        
        }
        .input-width{
            width: 200px;
        }
    }
    .table-box{
        border-radius: 5px;
    }
    .pagination-box{
        margin: 20px 0;
        display: flex;
        justify-content: flex-end;
    }
    .el-dialog .el-dialog__header{
        background: #f1f2f7;
    }
}
</style>
